import React from 'react';
import styled from 'styled-components';
import { animated } from 'react-spring';

import { breakpoints, colors } from '../../constants';

interface IProps {
    color?: string;
    buttonColor?: string;
    onClick?(): void;
    transparent?: boolean;
}

const BaseButton: React.FC<
    React.ButtonHTMLAttributes<HTMLButtonElement> & IProps
> = ({ buttonColor, transparent, ...other }) => <animated.button {...other} />;

export const Button = styled(BaseButton)<IProps>`
    appearance: none;
    border: 0;
    border-radius: 5px;
    background-color: ${(props) => props.buttonColor || colors.greenPrimary};
    color: ${({ color }) => color || colors.white};
    padding: 0 80px;
    font-size: 15px;
    cursor: pointer;
    height: 46px;

    @media (${breakpoints.mediumMin}) {
        height: 60px;
        font-size: 20px;
    }

    &:focus {
        outline: 1px solid ${colors.greenPrimary};
    }

    &:disabled {
        background-color: ${colors.greyDark};
    }
`;
